import type { ToasterProps } from "sonner";

export function sonnerToastOptions(
  toastOptions: ToasterProps["toastOptions"],
  isMobile: boolean,
): ToasterProps["toastOptions"] {
  const classNames = toastOptions?.classNames;

  return {
    ...toastOptions,
    duration: isMobile ? 2400 : toastOptions?.duration,
    classNames: {
      ...classNames,
      toast: [
        "cn-toast",
        "max-sm:min-h-0 max-sm:px-3 max-sm:py-2 max-sm:text-sm max-sm:shadow-lg",
        classNames?.toast,
      ]
        .filter(Boolean)
        .join(" "),
      title: ["max-sm:text-sm max-sm:font-semibold max-sm:leading-tight", classNames?.title]
        .filter(Boolean)
        .join(" "),
      description: ["max-sm:text-xs max-sm:leading-snug", classNames?.description]
        .filter(Boolean)
        .join(" "),
    },
  };
}
